import { ListingItem } from '@smg-real-estate/hg-search-libs';

import { InteractionContainerName } from '@/helpers/GTM/GTMParameters';

export interface FavouriteListingDescriptor {
  savedOn: number;
  listingId: string;
}

export enum FavouritesModuleStatus {
  UNINITIALIZED,
  INITIALIZED,
}

export interface FavouritesState {
  isFavouritesEnabled: boolean;
  favouritesModuleStatus: FavouritesModuleStatus;
  favouriteListingDescriptors: FavouriteListingDescriptor[];
  favouritesListId: string | null;
  isFavouritesButtonDisabled: boolean;
  favouriteListingRecords: ListingItem[];
  unavailableListingIds: string[];
}

export interface SaveFavouriteActionPayload {
  listingId: string;
  pageInteractionName: InteractionContainerName.PDP;
  listingItem: ListingItem;
}
